import { applyRubricSettings } from "@/utils/rubricSettings";

export default {
  inject: {
    updateRubricSettings: {
      from: "updateRubricSettings",
      default: null,
    },
    newRubricData: {
      from: "newRubricData",
      default: null,
    },
  },
  data() {
    return {
      rubricFormData: {
        name: "",
        type: "Advanced",
        intensity: "moderate",
        criterias: [],
      },
    };
  },
  methods: {
    handleFormDataUpdate(formData) {
      this.rubricFormData = formData;
    },

    updateSettingsFromRubric(rubric) {
      if (!this.updateRubricSettings) return;
      applyRubricSettings(
        rubric,
        this.updateRubricSettings,
        this.newRubricData
      );
    },

    initializeSettingsFromRubric(rubric, targetSettings, data) {
      applyRubricSettings(
        rubric,
        (key, value) => {
          targetSettings[key] = value;
        },
        data
      );
    },

    emitRubricBuilderOpened() {
      this.$nextTick(() => {
        this.$eventBus.$emit("onboarding:opened:rubricBuilder");
      });
    },
  },
};
